import React, { useState } from "react";
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import CategoryIcon from "@mui/icons-material/Category";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import DashboardIcon from "@mui/icons-material/Dashboard";
import SettingsIcon from "@mui/icons-material/Settings";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import TuneIcon from "@mui/icons-material/Tune";
import { AppState } from "../../redux/reducer/rootReducer";
import { useSelector } from "react-redux";

const menuAdminItems = [
  { text: "Dashboard", icon: DashboardIcon, link: "/" },
  { text: "Products", icon: Inventory2Icon, link: "/Products" },
  { text: "Parts", icon: SettingsIcon, link: "/Parts" },
  { text: "Categories", icon: CategoryIcon, link: "/Categories" },
  {
    text: "Manufacturer",
    icon: PrecisionManufacturingIcon,
    link: "/Manufacturer",
  },
  { text: "Orders", icon: LibraryBooksIcon, link: "/Orders" },
  { text: "Dealer Settings", icon: TuneIcon, link: "/DealerSettings" },
];

const menuItems = [
  { text: "Dashboard", icon: DashboardIcon, link: "/" },
  { text: "Products", icon: Inventory2Icon, link: "/Products" },
  { text: "Parts", icon: SettingsIcon, link: "/Parts" },
];
export const AdminLeftMenu: React.FunctionComponent = () => {
  const { role } = useSelector((state: AppState) => state.authReducer);
  const location = useLocation();
  const currentPath = location.pathname;
  return (
    <>
      {(role === "Admin" ? menuAdminItems : menuItems).map((item, index) => (
        <ListItem
          key={index}
          disablePadding
          sx={{
            display: "block",
            backgroundColor: currentPath === item.link ? "#80808066" : "none",
          }}
        >
          <ListItemButton
            className="left-menu-button"
            component={Link}
            to={item.link}
          >
            <ListItemIcon
              sx={{
                mr: 3,
              }}
            >
              <item.icon sx={{ color: "#ffff" }} />
            </ListItemIcon>
            <ListItemText primary={item.text} />
          </ListItemButton>
        </ListItem>
      ))}
    </>
  );
};
